import { baseApi } from 'shared/api';

import {
  BaseResponse,
  LedgerAccountEvent,
  PurchaseInvoicesSummary,
  PurchaseInvoiceBaseModel,
  PurchaseInvoiceModel,
  PurchaseInvoiceMonthsInformation,
} from 'models';

import { GetRequestParams, GetPurchaseInvoiceRequestParams } from './types';

import {
  buildRequestSearchParams,
  processLedgerAccountEvents,
} from './helpers';

export const purchaseInvoicesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSummaryInfo: build.query<PurchaseInvoicesSummary, GetRequestParams>({
      query: (requestParams) => ({
        url: `/cooperatives/${
          requestParams.coopId
        }/purchase-invoices/summary?${buildRequestSearchParams(requestParams)}`,
        method: 'GET',
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      transformResponse: (response: BaseResponse<PurchaseInvoicesSummary>) =>
        response.Data,
    }),
    getPurchaseInvoicesList: build.query<
      PurchaseInvoiceBaseModel[],
      GetRequestParams
    >({
      query: (requestParams) => ({
        url: `/cooperatives/${
          requestParams.coopId
        }/purchase-invoices?${buildRequestSearchParams(requestParams)}`,
        method: 'GET',
      }),
      transformResponse: (response: BaseResponse<PurchaseInvoiceBaseModel[]>) =>
        response.Data,
    }),
    getPurchaseInvoice: build.query<
      PurchaseInvoiceModel,
      GetPurchaseInvoiceRequestParams
    >({
      query: ({ coopId, invoiceId }) => ({
        url: `/cooperatives/${coopId}/purchase-invoices/${invoiceId}`,
        method: 'GET',
      }),
      transformResponse: (response: BaseResponse<PurchaseInvoiceModel>) =>
        response.Data,
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
    getPurchaseInvoiceMonths: build.query<
      PurchaseInvoiceMonthsInformation,
      GetPurchaseInvoiceRequestParams
    >({
      query: ({ coopId, invoiceId }) => ({
        url: `/cooperatives/${coopId}/purchase-invoices/${invoiceId}/months`,
        method: 'GET',
      }),
      transformResponse: (
        response: BaseResponse<PurchaseInvoiceMonthsInformation>
      ) => response.Data,
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
    getLedgerAccountEvents: build.query<
      LedgerAccountEvent[],
      GetPurchaseInvoiceRequestParams
    >({
      query: ({ coopId, invoiceId }) => ({
        url: `/cooperatives/${coopId}/purchase-invoices/${invoiceId}/ledger-account-events`,
        method: 'GET',
      }),
      transformResponse: (response: BaseResponse<LedgerAccountEvent[]>) =>
        processLedgerAccountEvents(response.Data),
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
  }),
});
